import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GenericList } from '../../commons/generic.responses';
import { States } from '../../static/usa-states';

@Component({
  selector: 'app-state-search',
  templateUrl: './state-search.component.html',
  styleUrl: './state-search.component.scss'
})
export class StateSearchComponent implements OnInit {

  @Input() idx: number;
  @Input() readMode: boolean;
  @Input() defaultValue: string = null;

  @Output() searchEvent = new EventEmitter<string>();

  searchState: string = '';
  states: GenericList[] = [];

  ngOnInit(): void {
    this.searchState = this.defaultValue;
  }

  SearchState() {
    this.states = States
      .filter(x => x.descr.toLowerCase().includes(this.searchState.toLowerCase()) || x.id.toString().toLowerCase() == this.searchState.toLowerCase())
      .splice(0, 10);
  }

  NotifyParent() {
    this.searchEvent.emit(this.searchState);
  }

}
